import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TBannerLink } from './models';

export const BannerLink: FC<React.PropsWithChildren<TBannerLink>> = ({
    Link,
    children,
    key,
    link,
    selected,
    styles,
    title,
}) => {
    if (link) {
        return (
            <Link
                key={key}
                border="hidden"
                className={selected ? cn(styles.topRowSelect, styles.external) : styles.link}
                href={link}
                title={title}
            >
                {children}
            </Link>
        );
    }

    return <>{children}</>;
};
